// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global variables adn mixins are defined here */
::ng-deep .cdk-global-scrollblock {
  overflow: hidden;
}

::ng-deep mat-pseudo-checkbox {
  width: 0px !important;
}

::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  width: auto !important;
}

::ng-deep .mdc-list-item__primary-text {
  margin: 0px !important;
}

::ng-deep .mdc-tab__ripple {
  display: none;
}

::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled ~ .mdc-checkbox__background {
  background-color: #3e97ff !important;
  border-color: #3e97ff !important;
}

.toaster {
  background-color: #f4f7ff !important;
}

/* variables */
/* MIXINS */
/* mixin for border radius */
/* To create a section at the center of window */
/* To include and adjust background image */
/* to split the input */
/* box-shadow generator
    \$clr- in RGBA format
 */
/*
remove the autofilled background color
*/
/* mixin for create buttons */
/* generate margin & padding */
/* to set the table row */
/* to set the image */
/* to set the styles for first and last child div */
/* to set the font style */
.ast-table .table {
  margin-bottom: 0px;
}
.ast-table table thead th {
  background-color: #edeced;
  border: 1px solid #dee2e6;
  border-top: none !important;
}
.ast-table table td {
  background-color: #fafafa;
  color: #231f20;
  border: 0.5px solid #e2e2e1;
  font-size: 16px;
  font-weight: 500;
  font-family: "Amazon Ember Display Light";
}

/* To create a card at the center */
::ng-deep mat-pseudo-checkbox {
  display: none !important;
}

::ng-deep .mat-calendar-body-selected {
  background-color: #3e97ff !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {
  border-bottom: none !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {
  border-bottom: none !important;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  background-color: #f2f4ff !important;
}

::ng-deep .mat-form-field {
  border: none !important;
}

.dateselect mat-form-field {
  display: flex;
  height: 25px;
  width: 185px;
  font-size: 12px;
  text-align: center;
  height: 24px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-top: 7px;
  margin-left: 8px;
}
.dateselect mat-form-field mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.dateselect mat-form-field mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.dateselect mat-form-field ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.dateselect mat-form-field mat-label {
  font-size: 12px;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle {
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle button {
  margin-left: 35px;
  width: 20px !important;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

::ng-deep .mat-mdc-form-field-icon-suffix,
[dir=rtl] .mat-mdc-form-field-icon-prefix {
  width: 30px !important;
  margin-top: 10px;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  align-items: center;
  border-radius: 5px;
}

::ng-deep .mat-mdc-icon-button {
  --mat-icon-button-hover-state-layer-opacity: 0 !important;
}

::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {
  display: none;
}

.tab-header ::ng-deep .mat-mdc-tab-list {
  align-content: center;
}
.tab-header ::ng-deep .mat-mdc-tab-links {
  gap: 5px;
}

/** Date Picker **/
::ng-deep mat-datepicker-toggle {
  width: 0 !important;
}
::ng-deep mat-datepicker-toggle button {
  position: absolute;
  /* margin-bottom: -20px; */
  top: -23% !important;
  right: 40px;
}

.date-picker {
  height: 25px;
  min-width: 180px;
  font-size: 12px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin: 7px 0;
}
.date-picker mat-form-field {
  width: 210px;
}
.date-picker ::ng-deep .mdc-text-field {
  padding-left: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  padding: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {
  height: 23px;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
.date-picker mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-inner {
  letter-spacing: 0.5px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-container {
  justify-content: center;
  font-family: "Poppins";
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 10px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-end-wrapper {
  flex-grow: initial !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-wrapper {
  width: 70px;
}
.date-picker mat-label {
  font-size: 12px;
}
.date-picker ::ng-deep mat-datepicker-toggle button {
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
  transform: translateX(10px);
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
  background-position: center;
}
.date-picker ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

/** Date Picker **/
.back-button,
.close-button {
  width: 35px;
  height: 35px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all 0.25s;
}

.back-button {
  background-image: url('back.svg');
}
.back-button:hover {
  background-image: url('back-hover.svg');
}

.close-button {
  background-image: url('close-circle.svg');
}
.close-button:hover {
  background-image: url('close-cirlce-hover.svg');
}

/* Global variables adn mixins are defined here */
::ng-deep .cdk-global-scrollblock {
  overflow: hidden;
}

::ng-deep mat-pseudo-checkbox {
  width: 0px !important;
}

::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  width: auto !important;
}

::ng-deep .mdc-list-item__primary-text {
  margin: 0px !important;
}

::ng-deep .mdc-tab__ripple {
  display: none;
}

::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled ~ .mdc-checkbox__background {
  background-color: #3e97ff !important;
  border-color: #3e97ff !important;
}

.toaster {
  background-color: #f4f7ff !important;
}

/* variables */
/* MIXINS */
/* mixin for border radius */
/* To create a section at the center of window */
/* To include and adjust background image */
/* to split the input */
/* box-shadow generator
    \$clr- in RGBA format
 */
/*
remove the autofilled background color
*/
/* mixin for create buttons */
/* generate margin & padding */
/* to set the table row */
/* to set the image */
/* to set the styles for first and last child div */
/* to set the font style */
.ast-table .table {
  margin-bottom: 0px;
}
.ast-table table thead th {
  background-color: #edeced;
  border: 1px solid #dee2e6;
  border-top: none !important;
}
.ast-table table td {
  background-color: #fafafa;
  color: #231f20;
  border: 0.5px solid #e2e2e1;
  font-size: 16px;
  font-weight: 500;
  font-family: "Amazon Ember Display Light";
}

/* To create a card at the center */
::ng-deep mat-pseudo-checkbox {
  display: none !important;
}

::ng-deep .mat-calendar-body-selected {
  background-color: #3e97ff !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {
  border-bottom: none !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {
  border-bottom: none !important;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  background-color: #f2f4ff !important;
}

::ng-deep .mat-form-field {
  border: none !important;
}

.dateselect mat-form-field {
  display: flex;
  height: 25px;
  width: 185px;
  font-size: 12px;
  text-align: center;
  height: 24px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-top: 7px;
  margin-left: 8px;
}
.dateselect mat-form-field mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.dateselect mat-form-field mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.dateselect mat-form-field ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.dateselect mat-form-field mat-label {
  font-size: 12px;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle {
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle button {
  margin-left: 35px;
  width: 20px !important;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

::ng-deep .mat-mdc-form-field-icon-suffix,
[dir=rtl] .mat-mdc-form-field-icon-prefix {
  width: 30px !important;
  margin-top: 10px;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  align-items: center;
  border-radius: 5px;
}

::ng-deep .mat-mdc-icon-button {
  --mat-icon-button-hover-state-layer-opacity: 0 !important;
}

::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {
  display: none;
}

.tab-header ::ng-deep .mat-mdc-tab-list {
  align-content: center;
}
.tab-header ::ng-deep .mat-mdc-tab-links {
  gap: 5px;
}

/** Date Picker **/
::ng-deep mat-datepicker-toggle {
  width: 0 !important;
}
::ng-deep mat-datepicker-toggle button {
  position: absolute;
  /* margin-bottom: -20px; */
  top: -23% !important;
  right: 40px;
}

.date-picker {
  height: 25px;
  min-width: 180px;
  font-size: 12px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin: 7px 0;
}
.date-picker mat-form-field {
  width: 210px;
}
.date-picker ::ng-deep .mdc-text-field {
  padding-left: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  padding: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {
  height: 23px;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
.date-picker mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-inner {
  letter-spacing: 0.5px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-container {
  justify-content: center;
  font-family: "Poppins";
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 10px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-end-wrapper {
  flex-grow: initial !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-wrapper {
  width: 70px;
}
.date-picker mat-label {
  font-size: 12px;
}
.date-picker ::ng-deep mat-datepicker-toggle button {
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
  transform: translateX(10px);
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
  background-position: center;
}
.date-picker ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

/** Date Picker **/
.back-button,
.close-button {
  width: 35px;
  height: 35px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all 0.25s;
}

.back-button {
  background-image: url('back.svg');
}
.back-button:hover {
  background-image: url('back-hover.svg');
}

.close-button {
  background-image: url('close-circle.svg');
}
.close-button:hover {
  background-image: url('close-cirlce-hover.svg');
}

::ng-deep .mdc-list-item__primary-text:hover {
  color: #3e97ff !important;
}

::ng-deep .mat-mdc-checkbox label {
  font-family: "Poppins" !important;
}

::ng-deep .mat-mdc-select-placeholder {
  padding-left: 8px !important;
}

::ng-deep .mat-mdc-select-min-line {
  padding-left: 8px !important;
}

::ng-deep .mat-mdc-option.mdc-list-item:hover {
  background-color: #f2f4ff !important;
}
::ng-deep .mat-mdc-option.mdc-list-item:hover .mdc-list-item__primary-text {
  color: #3e97ff !important;
}

.selecting:focus {
  box-shadow: 0 0 0 0.25rem rgba(62, 151, 255, 0.25);
}
.selecting ::ng-deep .mat-mdc-select {
  width: 100% !important;
}

.searchText {
  display: flex;
  align-items: center;
  border: 1px solid #e1e3ea;
  border-radius: 5px;
}
.searchText input {
  border: none;
  box-shadow: none;
}

.searchImg {
  width: 20px;
  height: 15px;
  padding-left: 5px;
}

.role {
  display: grid;
}

.create-role,
.user-details {
  width: 100%;
  padding: 10px 10px;
  background-color: #ffffff;
}

.create-action {
  display: inline-block;
  margin-bottom: 0;
  line-height: 15.5px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 300;
  height: 31px;
  min-width: 100px;
  background: #3e97ff;
  color: #ffffff;
  position: relative;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  border: none !important;
  position: relative;
  overflow: hidden;
  transition: background 0.5s;
}
.create-action:disabled {
  cursor: not-allowed;
}
.create-action:focus {
  outline: none;
}
.create-action:hover, .create-action:focus, .create-action:active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  text-decoration: none;
}
.create-action:hover, .create-action:focus, .create-action:active {
  background: #3e97ff;
  color: #ffffff;
  border: 1px solid #3e97ff;
}
.create-action span {
  color: #ffffff;
  position: relative;
  z-index: 10000;
  padding-left: 2px;
}

.hoverEffect::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #1e2238, #1e2238);
  transition: left 0.5s;
}

.hoverEffect:hover::before {
  left: 0;
}

.cancel-action {
  display: inline-block;
  margin-bottom: 0;
  line-height: 15.5px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 300;
  height: 31px;
  min-width: 100px;
  background: #e1e3ea;
  color: #959cbd;
  position: relative;
  text-align: center;
  margin-right: 10px;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  border: none !important;
  position: relative;
  overflow: hidden;
  transition: background 0.5s;
}
.cancel-action:disabled {
  cursor: not-allowed;
}
.cancel-action:focus {
  outline: none;
}
.cancel-action:hover, .cancel-action:focus, .cancel-action:active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  text-decoration: none;
}
.cancel-action:hover, .cancel-action:focus, .cancel-action:active {
  background: #e1e3ea;
  color: #959cbd;
  border: 1px solid #e1e3ea;
}
.cancel-action span {
  position: relative;
  z-index: 9;
  padding-left: 2px;
}

.cancel-action::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #1e2238, #1e2238);
  transition: left 0.5s;
}

.cancel-action:hover::before {
  left: 0;
}

.user-details {
  padding-bottom: 15px;
  padding-right: 10px;
}

.addSites {
  display: flex;
}

.searchForm {
  width: 250px;
}

.err-msg {
  color: #f44336 !important;
  letter-spacing: 0.5px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 12px;
  margin-top: 5px;
}

.fullLength div.form-group {
  width: 90% !important;
  max-width: 495px !important;
}

.create-role {
  padding: 0px 20px 0px 20px;
  justify-content: space-between;
  border-radius: 5px;
}
.create-role div.form-group {
  width: 100%;
  max-width: 200px;
  max-width: 400px;
}
.create-role div.form-group:not(:first-child) {
  margin-left: 0px;
  margin-bottom: 0px;
}
.create-role .form-group .mat-form-field {
  display: block !important;
}
.create-role .form-group .mat-form-field .mat-form-field-flex {
  border-bottom: 1px solid;
}

.not-found {
  color: black;
  background: #f5f7fa;
  padding: 20px;
  font-size: 14px;
}

.header {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  padding-left: 10px;
  padding-right: 20px;
}

.vendor-txt {
  color: #3e97ff;
  font-size: 20px;
  padding: 10px;
  font-weight: 600;
  padding-top: 0px;
}

.container {
  min-width: 100%;
  padding: 0px;
}

.grid-layout-custom {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  max-height: 250px;
  overflow-y: auto;
  margin-bottom: 10px;
  overflow-x: auto;
  background-color: #f5f7fa;
}

.site-checkbox {
  width: 200px;
  padding-left: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.site-checkbox > div {
  font-family: "Poppins", sans-serif !important;
  font-weight: 500 !important;
}

.assigned {
  color: 1;
  font-size: medium;
}

mat-select {
  background: #f3f6f9;
  padding: 5px;
  font-size: 14px;
  border-radius: 5px;
}

.available {
  color: 1;
  font-size: medium;
}

.login {
  margin-top: 20px;
}

.form-group {
  max-width: 500px;
  width: 100%;
  padding: 0px;
}
.form-group input:-webkit-autofill,
.form-group input:-webkit-autofill:hover,
.form-group input:-webkit-autofill:focus,
.form-group input:-webkit-autofill:active {
  transition-delay: 99999s;
  -webkit-transition-delay: 99999s;
}
.form-group label {
  font-size: 14px;
  color: #181c32;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
}
.form-group .form-title {
  font-size: 20px !important;
}
.form-group .form-control {
  height: calc(1.5em + 0.75rem + 4px) !important;
  border: none;
  font-size: 14px;
  font-weight: 500;
  background-color: #f3f6f9;
  color: #3f4254;
}
.form-group .form-control:disabled {
  cursor: not-allowed;
  border: none;
  box-shadow: none;
}
.form-group .error-section {
  min-height: 18px;
}

.user-details .form-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}
@media (max-width: 768px) {
  .user-details .form-container {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 570px) {
  .user-details .form-container {
    grid-template-columns: 1fr;
  }
}
.user-details .fm-title {
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  color: #3e97ff;
  margin-bottom: 10px;
  padding-left: 0px;
}
.user-details .fm-titlee {
  width: 100%;
  font-size: 16px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-left: 5px;
  color: #3f4254;
  padding: 0px;
  margin-bottom: 10px;
}
.user-details .custom-search {
  margin-left: 40px;
}
.user-details .add-site {
  width: 100%;
  opacity: 1;
  max-height: 250px;
  height: 100%;
  margin-left: 5px;
  margin-bottom: 10px;
}
.user-details .add-site label {
  font-size: 18px;
  text-align: center;
  padding-top: 10px;
  padding-left: 5px;
}
.user-details .add-site input {
  width: 15px;
  height: 15px;
}
.user-details .item-class {
  position: absolute;
  left: 0;
  padding-left: 20px;
}
.user-details .row {
  padding-right: 10px;
  padding: 0px 10px;
}
.user-details .roles-container {
  width: 100%;
}
.user-details mat-grid-tile {
  flex-direction: column;
}
.user-details .form-group {
  max-width: 500px;
  width: 100%;
  padding: 0px;
}
.user-details .form-group input:-webkit-autofill,
.user-details .form-group input:-webkit-autofill:hover,
.user-details .form-group input:-webkit-autofill:focus,
.user-details .form-group input:-webkit-autofill:active {
  transition-delay: 99999s;
  -webkit-transition-delay: 99999s;
}
.user-details .form-group label {
  font-size: 14px;
  font-weight: 500;
}
.user-details .form-group .form-title {
  font-size: 20px !important;
}
.user-details .form-group .form-control {
  height: calc(1.5em + 0.75rem + 4px) !important;
  border: none;
  font-size: 14px;
  background-color: #f3f6f9;
}
.user-details .form-group .form-control:disabled {
  cursor: not-allowed;
  border: none;
  box-shadow: none;
}
.user-details .form-group .error-section {
  min-height: 18px;
}

.form-title {
  font-size: 20px;
  margin-top: 40px;
  font-weight: normal;
}

.form-actions {
  padding: 35px 35px 0 0;
  padding-top: 0px;
  padding-right: 0px;
  width: 100%;
  text-align: right;
}
.form-actions .submit-class {
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
}
.form-actions .submit-class {
  display: inline-block;
  margin-bottom: 0;
  line-height: 20px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 20px;
  font-size: 18px;
  font-weight: 300;
  height: 40px;
  min-width: 120px;
  background: #3e97ff;
  color: #ffffff;
  position: relative;
  text-align: center;
  margin-top: -5%;
}
.form-actions .submit-class:disabled {
  cursor: not-allowed;
}
.form-actions .submit-class:focus {
  outline: none;
}
.form-actions .submit-class:hover, .form-actions .submit-class:focus, .form-actions .submit-class:active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  text-decoration: none;
}
.form-actions .cancel-class {
  display: inline-block;
  margin-bottom: 0;
  line-height: 20px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 20px;
  font-size: 18px;
  font-weight: 300;
  height: 40px;
  min-width: 120px;
  background: #ffffff;
  color: #3e97ff;
  position: relative;
  text-align: center;
  border: 1px solid #3e97ff;
  margin-right: 10px;
  margin-top: -5%;
}
.form-actions .cancel-class:disabled {
  cursor: not-allowed;
}
.form-actions .cancel-class:focus {
  outline: none;
}
.form-actions .cancel-class:hover, .form-actions .cancel-class:focus, .form-actions .cancel-class:active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  text-decoration: none;
}

.permissions-main-div {
  max-height: 45vh;
  overflow-y: auto;
  padding: 1% 3% 2% 0.5%;
  border: 1px solid #ccc;
  margin-top: 1%;
  margin-bottom: 1%;
}

.each-row-cls {
  padding-bottom: 7px;
}

.permissions-indvi-col {
  padding-left: 0px !important;
}

.module-name {
  font-size: 16px;
  font-weight: 600;
}

.set-name {
  word-break: break-word;
  white-space: pre-wrap;
}

@media (min-width: 522px) and (max-width: 772px) {
  .add-site {
    margin-left: 10px;
    opacity: 1;
    max-height: 200px;
    margin-left: 5px;
    margin-bottom: 10px;
    width: 70%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    margin-bottom: 20px;
  }
}
@media (max-width: 768px) {
  .create-role {
    height: -moz-fit-content;
    height: fit-content;
  }
}
@media (max-width: 767px) {
  .details {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .details .form-group {
    width: 90%;
  }
  .header {
    display: flex;
    width: 100%;
    flex-direction: column;
  }
  .form-actions {
    display: flex;
    justify-content: right;
    margin-left: 20px;
  }
  .layout-header {
    width: 100%;
  }
  .addSites {
    display: grid;
  }
}
@media (max-width: 300px) {
  .details {
    display: grid;
    grid-template-columns: 1fr;
  }
  .details .form-group {
    width: 90%;
  }
  .searchText {
    width: 160px;
  }
  .header {
    margin-bottom: 25px;
  }
}
* {
  font-family: "Poppins";
}

.container {
  padding-right: 30px;
}

::ng-deep .mat-mdc-checkbox label {
  font-family: "Poppins" !important;
}

.available {
  max-height: 250px;
  overflow-y: scroll;
  background-color: #f9f9f9;
  margin: 20px;
  margin-bottom: 0px;
}

.assigned {
  background-color: #f9f9f9;
  margin: 20px;
}

.add-site {
  overflow: hidden;
}

.fm-titlee {
  color: #181c32;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
}

.item-class {
  width: 150px;
}
.item-class label {
  padding-left: 5px;
}

mat-grid-tile {
  width: 210px !important;
}

.align {
  margin-top: 20px;
}

.grid-layout-custom {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  background-color: #f2f4ff;
}

.example-margin {
  width: 200px;
  padding-left: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.noSite {
  padding: 20px;
}
.noSite p {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/global.scss","webpack://./src/app/bas/my-profile/mysites/mysites.component.scss","webpack://./src/app/bas/users/prepare-users/prepare-users.component.scss"],"names":[],"mappings":"AAAA,iDAAA;AAEA;EACE,gBAAA;ACAF;;ADGA;EACE,qBAAA;ACAF;;ADGA;EACE,sBAAA;ACAF;;ADQA;EACE,sBAAA;ACLF;;ADQA;EACE,aAAA;ACLF;;ADQA;;;EAGE,oCAAA;EACA,gCAAA;ACLF;;ADQA;EACE,oCAAA;ACLF;;ADQA,cAAA;AAmDA,WAAA;AAEA,4BAAA;AAcA,gDAAA;AAuBA,2CAAA;AAaA,uBAAA;AAgBA;;EAAA;AAUA;;CAAA;AAcA,6BAAA;AAoEA,8BAAA;AASA,yBAAA;AAuBA,qBAAA;AAQA,mDAAA;AAaA,0BAAA;AAmBE;EACE,kBAAA;AC9QJ;ADsRM;EACE,yBAAA;EACA,yBAAA;EACA,2BAAA;ACpRR;ADwRI;EAtEF,yBAwE2B;EAvE3B,cAuEoC;EAtEpC,2BAsE6C;EArE7C,eAqEkE;EAnElE,gBAAA;EACA,yCAAA;AChNF;;ADuRA,mCAAA;AA8BA;EACE,wBAAA;ACjTF;;ADoTA;EACE,oCAAA;ACjTF;;ADoTA;EACE,8BAAA;ACjTF;;ADoTA;EACE,8BAAA;ACjTF;;ADoTA;EACE,oCAAA;ACjTF;;ADoTA;EACE,uBAAA;ACjTF;;ADqTE;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AClTJ;ADoTI;EAKE,yBAAA;EACA,aAAA;EACA,oBAAA;ACtTN;ADgTM;EACE,yBAAA;AC9SR;ADsTI;EACE,8BAAA;ACpTN;ADuTI;EACE,eAAA;ACrTN;ADwTI;EACE,0CAAA;EACA,4BAAA;ACtTN;ADwTM;EACE,iBAAA;EACA,sBAAA;ACtTR;ADyTM;EACE,wBAAA;ACvTR;;AD6TA;;EAEE,sBAAA;EACA,gBAAA;AC1TF;;AD6TA;EACE,mBAAA;EACA,kBAAA;AC1TF;;AD6TA;EACE,yDAAA;AC1TF;;AD6TA;EACE,aAAA;AC1TF;;AD8TE;EACE,qBAAA;AC3TJ;AD8TE;EACE,QAAA;AC5TJ;;ADiUA,kBAAA;AAEA;EACE,mBAAA;AC/TF;ADiUE;EACE,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,WAAA;AC/TJ;;ADmUA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;AChUF;ADkUE;EACE,YAAA;AChUJ;ADmUE;EACE,0BAAA;ACjUJ;ADoUE;EACE,qBAAA;AClUJ;ADqUE;EACE,YAAA;ACnUJ;ADsUE;EACE,mBAAA;EACA,qBAAA;EACA,oBAAA;ACpUJ;ADuUE;EACE,yBAAA;EACA,aAAA;EACA,oBAAA;ACrUJ;ADuUI;EACE,yBAAA;ACrUN;ADyUI;EACE,qBAAA;ACvUN;AD0UI;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;ACxUN;AD2UI;EACE,8BAAA;ACzUN;AD4UI;EACE,6BAAA;AC1UN;AD6UI;EACE,WAAA;AC3UN;AD+UE;EACE,eAAA;AC7UJ;ADiVI;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0CAAA;EACA,4BAAA;EACA,2BAAA;AC/UN;ADkVI;EACE,wBAAA;AChVN;;ADqVA,kBAAA;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;ACpVF;;ADuVA;EACE,iCAAA;ACpVF;ADsVE;EACE,uCAAA;ACpVJ;;ADwVA;EACE,yCAAA;ACrVF;ADuVE;EACE,+CAAA;ACrVJ;;ADlQA,iDAAA;AAEA;EACE,gBAAA;ACoQF;;ADjQA;EACE,qBAAA;ACoQF;;ADjQA;EACE,sBAAA;ACoQF;;AD5PA;EACE,sBAAA;AC+PF;;AD5PA;EACE,aAAA;AC+PF;;AD5PA;;;EAGE,oCAAA;EACA,gCAAA;AC+PF;;AD5PA;EACE,oCAAA;AC+PF;;AD5PA,cAAA;AAmDA,WAAA;AAEA,4BAAA;AAcA,gDAAA;AAuBA,2CAAA;AAaA,uBAAA;AAgBA;;EAAA;AAUA;;CAAA;AAcA,6BAAA;AAoEA,8BAAA;AASA,yBAAA;AAuBA,qBAAA;AAQA,mDAAA;AAaA,0BAAA;AAmBE;EACE,kBAAA;ACVJ;ADkBM;EACE,yBAAA;EACA,yBAAA;EACA,2BAAA;AChBR;ADoBI;EAtEF,yBAwE2B;EAvE3B,cAuEoC;EAtEpC,2BAsE6C;EArE7C,eAqEkE;EAnElE,gBAAA;EACA,yCAAA;ACoDF;;ADmBA,mCAAA;AA8BA;EACE,wBAAA;AC7CF;;ADgDA;EACE,oCAAA;AC7CF;;ADgDA;EACE,8BAAA;AC7CF;;ADgDA;EACE,8BAAA;AC7CF;;ADgDA;EACE,oCAAA;AC7CF;;ADgDA;EACE,uBAAA;AC7CF;;ADiDE;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AC9CJ;ADgDI;EAKE,yBAAA;EACA,aAAA;EACA,oBAAA;AClDN;AD4CM;EACE,yBAAA;AC1CR;ADkDI;EACE,8BAAA;AChDN;ADmDI;EACE,eAAA;ACjDN;ADoDI;EACE,0CAAA;EACA,4BAAA;AClDN;ADoDM;EACE,iBAAA;EACA,sBAAA;AClDR;ADqDM;EACE,wBAAA;ACnDR;;ADyDA;;EAEE,sBAAA;EACA,gBAAA;ACtDF;;ADyDA;EACE,mBAAA;EACA,kBAAA;ACtDF;;ADyDA;EACE,yDAAA;ACtDF;;ADyDA;EACE,aAAA;ACtDF;;AD0DE;EACE,qBAAA;ACvDJ;AD0DE;EACE,QAAA;ACxDJ;;AD6DA,kBAAA;AAEA;EACE,mBAAA;AC3DF;AD6DE;EACE,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,WAAA;AC3DJ;;AD+DA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;AC5DF;AD8DE;EACE,YAAA;AC5DJ;AD+DE;EACE,0BAAA;AC7DJ;ADgEE;EACE,qBAAA;AC9DJ;ADiEE;EACE,YAAA;AC/DJ;ADkEE;EACE,mBAAA;EACA,qBAAA;EACA,oBAAA;AChEJ;ADmEE;EACE,yBAAA;EACA,aAAA;EACA,oBAAA;ACjEJ;ADmEI;EACE,yBAAA;ACjEN;ADqEI;EACE,qBAAA;ACnEN;ADsEI;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;ACpEN;ADuEI;EACE,8BAAA;ACrEN;ADwEI;EACE,6BAAA;ACtEN;ADyEI;EACE,WAAA;ACvEN;AD2EE;EACE,eAAA;ACzEJ;AD6EI;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0CAAA;EACA,4BAAA;EACA,2BAAA;AC3EN;AD8EI;EACE,wBAAA;AC5EN;;ADiFA,kBAAA;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;AChFF;;ADmFA;EACE,iCAAA;AChFF;ADkFE;EACE,uCAAA;AChFJ;;ADoFA;EACE,yCAAA;ACjFF;ADmFE;EACE,+CAAA;ACjFJ;;ACpgBA;EACE,yBAAA;ADugBF;;ACpgBA;EACE,iCAAA;ADugBF;;ACpgBA;EACE,4BAAA;ADugBF;;ACpgBA;EACE,4BAAA;ADugBF;;ACpgBA;EACE,oCAAA;ADugBF;ACrgBE;EACE,yBAAA;ADugBJ;;AClgBE;EACE,kDAAA;ADqgBJ;AClgBE;EACE,sBAAA;ADogBJ;;AChgBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;ADmgBF;ACjgBE;EACE,YAAA;EACA,gBAAA;ADmgBJ;;AC/fA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;ADkgBF;;AC/fA;EACE,aAAA;ADkgBF;;AC/fA;;EAEE,WAAA;EACA,kBAAA;EACA,yBFeM;ACmfR;;AC/fA;EF+HE,qBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAzGA,kBE5BE;EFuIF,eEzIE;EF0IF,gBEzIE;EF0IF,YE5IE;EF6IF,gBE9IE;EF+IF,mBA7KQ;EA8KR,cAzIM;EA0IN,kBAAA;EACA,kBAAA;EE5IA,kCFMa;EELb,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;ADkhBF;ADzYE;EACE,mBAAA;AC2YJ;ADxYE;EACE,aAAA;AC0YJ;ADvYE;EAME,yBAAA;EACA,uCAAA;EACA,qBAAA;ACoYJ;AD9XE;EAGE,mBA3MM;EA4MN,cAvKI;EAwKJ,yBAAA;AC8XJ;AChiBE;EACE,cFPI;EEQJ,kBAAA;EACA,cAAA;EACA,iBAAA;ADkiBJ;;AC9hBA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;EACA,qBAAA;ADiiBF;;AC9hBA;EACE,OAAA;ADiiBF;;AC9hBA;EFsFE,qBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAzGA,kBEaE;EF8FF,eEhGE;EFiGF,gBEhGE;EFiGF,YEnGE;EFoGF,gBErGE;EFsGF,mBAzJS;EA0JT,cAxJS;EAyJT,kBAAA;EACA,kBAAA;EElGA,kBAAA;EACA,kCFrCa;EEsCb,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;ADgjBF;ADldE;EACE,mBAAA;ACodJ;ADjdE;EACE,aAAA;ACmdJ;ADhdE;EAME,yBAAA;EACA,uCAAA;EACA,qBAAA;AC6cJ;ADvcE;EAGE,mBAvLO;EAwLP,cAtLO;EAuLP,yBAAA;ACucJ;AC9jBE;EAEE,kBAAA;EACA,UAAA;EACA,iBAAA;AD+jBJ;;AC3jBA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;EACA,qBAAA;AD8jBF;;AC3jBA;EACE,OAAA;AD8jBF;;AC3jBA;EACE,oBAAA;EACA,mBAAA;AD8jBF;;AC3jBA;EACE,aAAA;AD8jBF;;AC3jBA;EACE,YAAA;AD8jBF;;AC3jBA;EACE,yBAAA;EACA,qBAAA;EACA,kCFnFa;EEoFb,gBAAA;EACA,eAAA;EACA,eAAA;AD8jBF;;AC1jBE;EACE,qBAAA;EACA,2BAAA;AD6jBJ;;ACzjBA;EACE,0BAAA;EACA,8BAAA;EACA,kBAAA;AD4jBF;AC1jBE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AD4jBJ;ACzjBE;EACE,gBAAA;EACA,kBAAA;AD2jBJ;ACvjBI;EACE,yBAAA;ADyjBN;ACvjBM;EACE,wBAAA;ADyjBR;;ACnjBA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;ADsjBF;;ACnjBA;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;ADsjBF;;ACnjBA;EACE,cFrLQ;EEsLR,eAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;ADsjBF;;ACnjBA;EACE,eAAA;EACA,YAAA;ADsjBF;;ACnjBA;EACE,aAAA;EACA,0CAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;ADsjBF;;ACnjBA;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;ADsjBF;;ACnjBA;EACE,6CAAA;EACA,2BAAA;ADsjBF;;ACnjBA;EACE,QAAA;EACA,iBAAA;ADsjBF;;ACnjBA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;ADsjBF;;ACnjBA;EACE,QAAA;EACA,iBAAA;ADsjBF;;ACnjBA;EACE,gBAAA;ADsjBF;;ACnjBA;EAGE,gBAAA;EACA,WAAA;EACA,YAAA;ADojBF;ADjqBE;;;;EAIE,wBAAA;EACA,gCAAA;ACmqBJ;ACzjBE;EACE,eAAA;EACA,cF3NO;EE4NP,gBAAA;EACA,kCF7MW;ACwwBf;ACxjBE;EACE,0BAAA;AD0jBJ;ACvjBE;EACE,8CAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cF3OO;ACoyBX;ACvjBI;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;ADyjBN;ACrjBE;EACE,gBAAA;ADujBJ;;ACljBE;EACE,WAAA;EACA,aAAA;EACA,qCAAA;EAEA,SAAA;ADojBJ;ACljBI;EAPF;IAQI,qCAAA;EDqjBJ;AACF;ACnjBI;EAXF;IAYI,0BAAA;EDsjBJ;AACF;ACnjBE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cFvSM;EEwSN,mBAAA;EACA,iBAAA;ADqjBJ;ACljBE;EACE,WAAA;EACA,eAAA;EACA,kCFrQW;EEsQX,gBFnQK;EEoQL,gBAAA;EACA,cFzRO;EE0RP,YAAA;EACA,mBAAA;ADojBJ;ACjjBE;EACE,iBAAA;ADmjBJ;AChjBE;EACE,WAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;ADkjBJ;AChjBI;EACE,eAAA;EACA,kBAAA;EAEA,iBAAA;EACA,iBAAA;ADijBN;AC9iBI;EACE,WAAA;EAEA,YAAA;AD+iBN;AC3iBE;EACE,kBAAA;EACA,OAAA;EACA,kBAAA;AD6iBJ;AC1iBE;EACE,mBAAA;EACA,iBAAA;AD4iBJ;ACziBE;EACE,WAAA;AD2iBJ;ACxiBE;EACE,sBAAA;AD0iBJ;ACviBE;EAGE,gBAAA;EACA,WAAA;EACA,YAAA;ADuiBJ;AD7wBE;;;;EAIE,wBAAA;EACA,gCAAA;AC+wBJ;AC5iBI;EACE,eAAA;EACA,gBAAA;AD8iBN;AC3iBI;EACE,0BAAA;AD6iBN;AC1iBI;EACE,8CAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AD4iBN;AC1iBM;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;AD4iBR;ACxiBI;EACE,gBAAA;AD0iBN;;ACriBA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;ADwiBF;;ACriBA;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;ADwiBF;ACtiBE;EACE,2CAAA;ADwiBJ;ACriBE;EFjQA,qBAAA;EAEA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAzGA,mBEoWI;EFzPJ,eEuPI;EFtPJ,gBEuPI;EFtPJ,YEoPI;EFnPJ,gBEkPI;EFjPJ,mBA7KQ;EA8KR,cAzIM;EA0IN,kBAAA;EACA,kBAAA;EEmPE,eAAA;ADwjBJ;ADzyBE;EACE,mBAAA;AC2yBJ;ADxyBE;EACE,aAAA;AC0yBJ;ADvyBE;EAME,yBAAA;EACA,uCAAA;EACA,qBAAA;ACoyBJ;AChkBE;EF9QA,qBAAA;EAEA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAzGA,mBEiXI;EFtQJ,eEoQI;EFnQJ,gBEoQI;EFnQJ,YEiQI;EFhQJ,gBE+PI;EF9PJ,mBAxIM;EAyIN,cA9KQ;EA+KR,kBAAA;EACA,kBAAA;EEgQE,yBAAA;EACA,kBAAA;EACA,eAAA;ADmlBJ;ADn1BE;EACE,mBAAA;ACq1BJ;ADl1BE;EACE,aAAA;ACo1BJ;ADj1BE;EAME,yBAAA;EACA,uCAAA;EACA,qBAAA;AC80BJ;;AC1lBA;EACE,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;AD6lBF;;AC1lBA;EACE,mBAAA;AD6lBF;;AC1lBA;EACE,4BAAA;AD6lBF;;AC1lBA;EACE,eAAA;EACA,gBAAA;AD6lBF;;AC1lBA;EACE,sBAAA;EACA,qBAAA;AD6lBF;;ACxlBA;EACE;IACE,iBAAA;IACA,UAAA;IACA,iBAAA;IACA,gBAAA;IACA,mBAAA;IACA,UAAA;IACA,aAAA;IACA,sBAAA;IACA,gBAAA;IACA,kBAAA;IAEA,mBAAA;ED0lBF;AACF;ACvlBA;EACE;IACE,wBAAA;IAAA,mBAAA;EDylBF;AACF;ACtlBA;EACE;IACE,aAAA;IACA,8BAAA;EDwlBF;ECtlBE;IACE,UAAA;EDwlBJ;ECplBA;IACE,aAAA;IACA,WAAA;IACA,sBAAA;EDslBF;ECnlBA;IACE,aAAA;IACA,sBAAA;IACA,iBAAA;EDqlBF;ECllBA;IACE,WAAA;EDolBF;ECjlBA;IACE,aAAA;EDmlBF;AACF;AChlBA;EACE;IACE,aAAA;IACA,0BAAA;EDklBF;EChlBE;IACE,UAAA;EDklBJ;EC9kBA;IACE,YAAA;EDglBF;EC7kBA;IACE,mBAAA;ED+kBF;AACF;AA7oCA;EACE,sBAAA;AA+oCF;;AA5oCA;EACE,mBAAA;AA+oCF;;AA5oCA;EACE,iCAAA;AA+oCF;;AA5oCA;EACE,iBAAA;EACA,kBAAA;EACA,yBDwCS;ECvCT,YAAA;EACA,kBAAA;AA+oCF;;AA5oCA;EACE,yBDkCS;ECjCT,YAAA;AA+oCF;;AAzoCA;EACE,gBAAA;AA4oCF;;AAzoCA;EACE,cDqBK;ECpBL,kCD6Ca;EC5Cb,gBDiDY;AC2lCd;;AAzoCA;EACE,YAAA;AA4oCF;AA1oCE;EACE,iBAAA;AA4oCJ;;AAxoCA;EACE,uBAAA;AA2oCF;;AAxoCA;EACE,gBAAA;AA2oCF;;AAxoCA;EACE,aAAA;EACA,8CAAA;EACA,yBDlBc;AC6pChB;;AAxoCA;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AA2oCF;;AAxoCA;EACE,aAAA;AA2oCF;AAzoCE;EACE,eAAA;AA2oCJ","sourcesContent":["/* Global variables adn mixins are defined here */\n\n::ng-deep .cdk-global-scrollblock {\n  overflow: hidden;\n}\n\n::ng-deep mat-pseudo-checkbox {\n  width: 0px !important;\n}\n\n::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  width: auto !important;\n  // height: auto !important;\n}\n\n// ::ng-deep mat-option{\n//     display: flex !important;\n//     justify-content: center !important;\n// }\n::ng-deep .mdc-list-item__primary-text {\n  margin: 0px !important;\n}\n\n::ng-deep .mdc-tab__ripple {\n  display: none;\n}\n\n::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=\"true\"]:enabled~.mdc-checkbox__background {\n  background-color: #3e97ff !important;\n  border-color: #3e97ff !important;\n}\n\n.toaster {\n  background-color: #f4f7ff !important;\n}\n\n/* variables */\n\n$primary: #3e97ff;\n$primary-active: #2884ef;\n$primary-light: #f2f4ff;\n$success: #50cd89;\n$success-active: #50cd89;\n$success-light: #e8fff3;\n$danger: #ff4b55;\n$danger-active: #d9214e;\n$danger-light: #fff5f8;\n$info: #7dcfdb;\n$info-active: #4fc9da;\n$info-light: #edf9fb;\n$warning: #ffa800;\n$warning-active: #ffa800;\n$warning-light: #fff7e7;\n$white: #ffffff;\n$white-active: #f5f8fa;\n$dark: #181c32;\n$gray-100: #f9f9f9;\n$gray-200: #f1f1f2;\n$gray-300: #e1e3ea;\n$gray-400: #d8d8e5;\n$gray-500: #959cbd;\n$gray-600: #7e8299;\n$gray-700: #5e6278;\n$gray-800: #3f4254;\n$gray-900: #181c32;\n$gray-button: #1e2238;\n\n//\n$primary-clr-dark: #232f3e;\n$primary-clr: #3e97ff;\n$primary-clr-alpha: #00a8e1;\n$bg-clr: #f3f3f3;\n$bg-clr-alpha: #edeced;\n$primary-ft-clr: #595a5c;\n$primary-grey: #707070;\n$white: #ffffff;\n$black: #3f4254;\n// $success: #347439;\n$failure: #ff0000;\n$grey: #cccccc;\n$primary-font: \"Poppins\", sans-serif;\n$ft-thin: 300;\n$ft-regular: 400;\n$ft-500: 500;\n$ft-bold: 700;\n$ft-semibold: 600;\n\n/* MIXINS */\n\n/* mixin for border radius */\n\n@mixin border-radius($top, $right, $bottom, $left) {\n  -webkit-border-radius: $top $right $bottom $left;\n  -moz-border-radius: $top $right $bottom $left;\n  border-radius: $top $right $bottom $left;\n}\n\n@mixin border-single-radius($rad) {\n  -webkit-border-radius: $rad;\n  -moz-border-radius: $rad;\n  border-radius: $rad;\n}\n\n/* To create a section at the center of window */\n@mixin create-centered-section($width,\n  $border-radius,\n  $padding-tb,\n  $padding-lr,\n  $border,\n  $background,\n  $left) {\n  position: absolute;\n  margin: auto;\n  top: 0;\n  left: $left;\n  right: 0;\n  bottom: 0;\n  width: $width;\n  height: 50vh;\n  // max-height: 520px;\n  border-radius: $border-radius;\n  padding: $padding-tb $padding-lr;\n  border: $border;\n  background: $background;\n}\n\n/* To include and adjust background image */\n@mixin set-background-image($bg-color,\n  $bg-url,\n  $bg-position,\n  $bg-repeat,\n  $bg-size) {\n  background: $bg-color;\n  background-image: $bg-url;\n  background-position: $bg-position;\n  background-repeat: $bg-repeat;\n  background-size: $bg-size;\n}\n\n/* to split the input */\n@mixin split-input($ltr-space,\n  $bg-img,\n  $bg-position,\n  $bg-size,\n  $bg-repeat,\n  $bg-pos-x) {\n  border: 0;\n  letter-spacing: $ltr-space;\n  background-image: $bg-img;\n  background-position: bottom;\n  background-size: $bg-size;\n  background-repeat: $bg-repeat;\n  background-position-x: $bg-pos-x;\n}\n\n/* box-shadow generator\n    $clr- in RGBA format\n */\n\n@mixin box-shadows($hset, $vset, $blur, $spread, $clr) {\n  -webkit-box-shadow: $hset $vset $blur $spread $clr;\n  -moz-box-shadow: $hset $vset $blur $spread $clr;\n  box-shadow: $hset $vset $blur $spread $clr;\n}\n\n/*\nremove the autofilled background color\n*/\n@mixin remove-autofill-background() {\n\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active {\n    transition-delay: 99999s;\n    -webkit-transition-delay: 99999s;\n  }\n}\n\n/* mixin for create buttons */\n\n@mixin create-buttons($bgClr,\n  $clr,\n  $ptb,\n  $plr,\n  $width,\n  $height,\n  $ft-size,\n  $ft-weight,\n  $rad) {\n  display: inline-block;\n  // padding: $ptb $plr;\n  margin-bottom: 0;\n  line-height: calc($height/2);\n  text-align: left;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  @include border-single-radius($rad);\n  font-size: $ft-size;\n  font-weight: $ft-weight;\n  height: $height;\n  min-width: $width;\n  background: $bgClr;\n  color: $clr;\n  position: relative;\n  text-align: center;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:hover,\n  &:focus,\n  &:active {\n    // background: $clr;\n    // color: $bgClr;\n    // border: 1px solid $bgClr;\n    transition-duration: 0.5s;\n    transition-timing-function: ease-in-out;\n    text-decoration: none;\n  }\n}\n\n@mixin no-transition($bg-color, $color) {\n\n  &:hover,\n  &:focus,\n  &:active {\n    background: $bg-color;\n    color: $color;\n    border: 1px solid $bg-color;\n  }\n}\n\n/* generate margin & padding */\n@mixin generate-margin($tp, $rt, $bt, $lt) {\n  margin: $tp $rt $bt $lt;\n}\n\n@mixin generate-padding($tp, $rt, $bt, $lt) {\n  padding: $tp $rt $bt $lt;\n}\n\n/* to set the table row */\n@mixin set-table-row($bg-color,\n  $color,\n  $border,\n  $font-size,\n  $font-weight,\n  $fontFamily: \"\"\n\n) {\n  background-color: $bg-color;\n  color: $color;\n  border: $border;\n  font-size: $font-size;\n  // font-weight: $font-weight;\n  font-weight: 500;\n  font-family: \"Amazon Ember Display Light\";\n\n  @if $fontFamily !=\"\" {\n    font-family: $fontFamily;\n    font-weight: $font-weight;\n  }\n}\n\n/* to set the image */\n@mixin set-image-config($width, $height, $cursor, $margin-right) {\n  width: $width;\n  height: $height;\n  cursor: $cursor;\n  margin-right: $margin-right;\n}\n\n/* to set the styles for first and last child div */\n@mixin set-child-div($color1, $font-size1, $font-weight1, $color2) {\n  div:first-child {\n    color: $color1;\n    font-size: $font-size1;\n    font-weight: $font-weight1;\n  }\n\n  div:last-child {\n    color: $color2;\n  }\n}\n\n/* to set the font style */\n@mixin set-font-config($fontSize,\n  $fontWeight,\n  $fontColor,\n  $textAlign,\n  $fontFamily: \"\"\n\n) {\n  font-size: $fontSize;\n  font-weight: $fontWeight;\n  color: $fontColor;\n  text-align: $textAlign;\n\n  @if $fontFamily !=\"\" {\n    font-family: $fontFamily;\n  }\n}\n\n.ast-table {\n  .table {\n    margin-bottom: 0px;\n  }\n\n  table {\n    thead {\n\n      // @mixin set-table-row($bg-color, $color, $border, $font-size, $font-weight)\n      // @include set-table-row($white, #231f20, 0.5px solid #e2e2e1, 16px, 300) ;\n      th {\n        background-color: #edeced;\n        border: 1px solid #dee2e6;\n        border-top: none !important;\n      }\n    }\n\n    td {\n      // @mixin set-table-row($bg-color, $color, $border, $font-size, $font-weight)\n      @include set-table-row(#fafafa, #231f20, 0.5px solid #e2e2e1, 16px, 300);\n    }\n  }\n}\n\n/* To create a card at the center */\n@mixin create-card($width,\n  $height,\n  $border-radius,\n  $padding-tb,\n  $padding-lr,\n  $border,\n  $background,\n  $left) {\n  position: relative;\n  margin: auto;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: $width;\n  height: $height;\n  border-radius: $border-radius;\n  padding: $padding-tb $padding-lr;\n  border: $border;\n  background: $background;\n  text-align: center;\n}\n\n@mixin flexbox($display, $align-items, $justify-content) {\n  display: $display;\n  align-items: $align-items;\n  justify-content: $justify-content;\n}\n\n::ng-deep mat-pseudo-checkbox {\n  display: none !important;\n}\n\n::ng-deep .mat-calendar-body-selected {\n  background-color: $primary !important;\n}\n\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {\n  border-bottom: none !important;\n}\n\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {\n  border-bottom: none !important;\n}\n\n::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n  background-color: $primary-light !important;\n}\n\n::ng-deep .mat-form-field {\n  border: none !important;\n}\n\n.dateselect {\n  mat-form-field {\n    display: flex;\n    height: 25px;\n    width: 185px;\n    font-size: 12px;\n    text-align: center;\n    height: 24px;\n    font-family: \"Poppins\", sans-serif;\n    font-weight: 500;\n    margin-top: 7px;\n    margin-left: 8px;\n\n    mat-date-range-input {\n      ::ng-deep .mat-date-range-input-separator {\n        color: #959cbd !important;\n      }\n\n      color: #959cbd !important;\n      display: flex;\n      justify-self: center;\n    }\n\n    ::ng-deep .mat-date-range-input-content {\n      border-bottom: none !important;\n    }\n\n    mat-label {\n      font-size: 12px;\n    }\n\n    ::ng-deep mat-datepicker-toggle {\n      background-image: url(../images/calendar-icon.svg);\n      background-repeat: no-repeat;\n\n      button {\n        margin-left: 35px;\n        width: 20px !important;\n      }\n\n      .mat-mdc-icon-button svg {\n        display: none !important;\n      }\n    }\n  }\n}\n\n::ng-deep .mat-mdc-form-field-icon-suffix,\n[dir=\"rtl\"] .mat-mdc-form-field-icon-prefix {\n  width: 30px !important;\n  margin-top: 10px;\n}\n\n::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n  align-items: center;\n  border-radius: 5px;\n}\n\n::ng-deep .mat-mdc-icon-button {\n  --mat-icon-button-hover-state-layer-opacity: 0 !important;\n}\n\n::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {\n  display: none;\n}\n\n.tab-header {\n  ::ng-deep .mat-mdc-tab-list {\n    align-content: center;\n  }\n\n  ::ng-deep .mat-mdc-tab-links {\n    gap: 5px;\n  }\n}\n\n\n/** Date Picker **/\n\n::ng-deep mat-datepicker-toggle {\n  width: 0 !important;\n\n  button {\n    position: absolute;\n    /* margin-bottom: -20px; */\n    top: -23% !important;\n    right: 40px;\n  }\n}\n\n.date-picker {\n  height: 25px;\n  min-width: 180px;\n  font-size: 12px;\n  text-align: center;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n  margin: 7px 0;\n\n  mat-form-field {\n    width: 210px;\n  }\n\n  ::ng-deep .mdc-text-field {\n    padding-left: 0 !important;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {\n    padding: 0 !important;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {\n    height: 23px;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {\n    width: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  mat-date-range-input {\n    color: #959cbd !important;\n    display: flex;\n    justify-self: center;\n\n    ::ng-deep .mat-date-range-input-separator {\n      color: #959cbd !important;\n      // margin: 0 10px;\n    }\n\n    ::ng-deep .mat-date-range-input-inner {\n      letter-spacing: 0.5px;\n    }\n\n    ::ng-deep .mat-date-range-input-container {\n      justify-content: center;\n      font-family: \"Poppins\";\n      width: fit-content;\n      margin: 0 10px;\n    }\n\n    ::ng-deep .mat-date-range-input-content {\n      border-bottom: none !important;\n    }\n\n    ::ng-deep .mat-date-range-input-end-wrapper {\n      flex-grow: initial !important;\n    }\n\n    ::ng-deep .mat-date-range-input-wrapper {\n      width: 70px;\n    }\n  }\n\n  mat-label {\n    font-size: 12px;\n  }\n\n  ::ng-deep mat-datepicker-toggle {\n    button {\n      width: 24px !important;\n      height: 24px !important;\n      padding: 0 !important;\n      transform: translateX(10px);\n      background-image: url(../images/calendar-icon.svg);\n      background-repeat: no-repeat;\n      background-position: center;\n    }\n\n    .mat-mdc-icon-button svg {\n      display: none !important;\n    }\n  }\n}\n\n/** Date Picker **/\n\n\n.back-button,\n.close-button {\n  width: 35px;\n  height: 35px;\n  background-position: center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  transition: all .25s;\n}\n\n.back-button {\n  background-image: url('../images/back.svg');\n\n  &:hover {\n    background-image: url('../images/back-hover.svg');\n  }\n}\n\n.close-button {\n  background-image: url('../images/close-circle.svg');\n\n  &:hover {\n    background-image: url('../images/close-cirlce-hover.svg');\n  }\n}","@import \"src/assets/styles/global.scss\";\n@import \"../../users/prepare-users/prepare-users.component.scss\";\n\n* {\n  font-family: \"Poppins\";\n}\n\n.container {\n  padding-right: 30px;\n}\n\n::ng-deep .mat-mdc-checkbox label {\n  font-family: \"Poppins\" !important;\n}\n\n.available {\n  max-height: 250px;\n  overflow-y: scroll;\n  background-color: $gray-100;\n  margin: 20px;\n  margin-bottom: 0px;\n}\n\n.assigned {\n  background-color: $gray-100;\n  margin: 20px;\n}\n\n// .container{\n//     margin: 20px;\n// }\n.add-site {\n  overflow: hidden;\n}\n\n.fm-titlee {\n  color: $dark;\n  font-family: $primary-font;\n  font-weight: $ft-semibold;\n}\n\n.item-class {\n  width: 150px;\n\n  label {\n    padding-left: 5px;\n  }\n}\n\nmat-grid-tile {\n  width: 210px !important;\n}\n\n.align {\n  margin-top: 20px;\n}\n\n.grid-layout-custom {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;\n  background-color: $primary-light;\n}\n\n.example-margin {\n  width: 200px;\n  padding-left: 30px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.noSite {\n  padding: 20px;\n\n  p {\n    font-size: 14px;\n  }\n}","@import \"src/assets/styles/global.scss\";\n\n::ng-deep .mdc-list-item__primary-text:hover {\n  color: $primary !important;\n}\n\n::ng-deep .mat-mdc-checkbox label {\n  font-family: \"Poppins\" !important;\n}\n\n::ng-deep .mat-mdc-select-placeholder {\n  padding-left: 8px !important;\n}\n\n::ng-deep .mat-mdc-select-min-line {\n  padding-left: 8px !important;\n}\n\n::ng-deep .mat-mdc-option.mdc-list-item:hover {\n  background-color: $primary-light !important;\n\n  .mdc-list-item__primary-text {\n    color: $primary !important;\n  }\n}\n\n.selecting {\n  &:focus {\n    box-shadow: 0 0 0 0.25rem rgba(62, 151, 255, 0.25);\n  }\n\n  ::ng-deep .mat-mdc-select {\n    width: 100% !important;\n  }\n}\n\n.searchText {\n  display: flex;\n  align-items: center;\n  border: 1px solid $gray-300;\n  border-radius: 5px;\n\n  input {\n    border: none;\n    box-shadow: none;\n  }\n}\n\n.searchImg {\n  width: 20px;\n  height: 15px;\n  padding-left: 5px;\n}\n\n.role {\n  display: grid;\n}\n\n.create-role,\n.user-details {\n  width: 100%;\n  padding: 10px 10px;\n  background-color: $white;\n}\n\n.create-action {\n  @include create-buttons($primary,\n    $white,\n    0px,\n    0px,\n    100px,\n    31px,\n    13px,\n    300,\n    5px);\n  @include no-transition($primary, $white);\n  font-family: $primary-font;\n  font-weight: 600;\n  border: none !important;\n  position: relative;\n  overflow: hidden;\n  transition: background 0.5s;\n\n  span {\n    color: $white;\n    position: relative;\n    z-index: 10000;\n    padding-left: 2px;\n  }\n}\n\n.hoverEffect::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to right, $gray-button, $gray-button);\n  transition: left 0.5s;\n}\n\n.hoverEffect:hover::before {\n  left: 0;\n}\n\n.cancel-action {\n  @include create-buttons($gray-300,\n    $gray-500,\n    0px,\n    0px,\n    100px,\n    31px,\n    13px,\n    300,\n    5px);\n  // @mixin no-transition($bg-color, $color)\n  @include no-transition($gray-300, $gray-500);\n  margin-right: 10px;\n  font-family: $primary-font;\n  font-weight: 600;\n  border: none !important;\n  position: relative;\n  overflow: hidden;\n  transition: background 0.5s;\n\n  span {\n    // color: $white;\n    position: relative;\n    z-index: 9;\n    padding-left: 2px;\n  }\n}\n\n.cancel-action::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to right, $gray-button, $gray-button);\n  transition: left 0.5s;\n}\n\n.cancel-action:hover::before {\n  left: 0;\n}\n\n.user-details {\n  padding-bottom: 15px;\n  padding-right: 10px;\n}\n\n.addSites {\n  display: flex;\n}\n\n.searchForm {\n  width: 250px;\n}\n\n.err-msg {\n  color: #f44336 !important;\n  letter-spacing: 0.5px;\n  font-family: $primary-font;\n  font-weight: 500;\n  font-size: 12px;\n  margin-top: 5px;\n}\n\n.fullLength {\n  div.form-group {\n    width: 90% !important;\n    max-width: 495px !important;\n  }\n}\n\n.create-role {\n  padding: 0px 20px 0px 20px;\n  justify-content: space-between;\n  border-radius: 5px;\n\n  div.form-group {\n    width: 100%;\n    max-width: 200px;\n    max-width: 400px;\n  }\n\n  div.form-group:not(:first-child) {\n    margin-left: 0px;\n    margin-bottom: 0px;\n  }\n\n  .form-group {\n    .mat-form-field {\n      display: block !important;\n\n      .mat-form-field-flex {\n        border-bottom: 1px solid;\n      }\n    }\n  }\n}\n\n.not-found {\n  color: black;\n  background: #f5f7fa;\n  padding: 20px;\n  font-size: 14px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 20px;\n  padding-left: 10px;\n  padding-right: 20px;\n}\n\n.vendor-txt {\n  color: $primary;\n  font-size: 20px;\n  padding: 10px;\n  font-weight: 600;\n  padding-top: 0px;\n}\n\n.container {\n  min-width: 100%;\n  padding: 0px;\n}\n\n.grid-layout-custom {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n  max-height: 250px;\n  overflow-y: auto;\n  margin-bottom: 10px;\n  overflow-x: auto;\n  background-color: #f5f7fa;\n}\n\n.site-checkbox {\n  width: 200px;\n  padding-left: 30px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.site-checkbox>div {\n  font-family: $primary-font !important;\n  font-weight: 500 !important;\n}\n\n.assigned {\n  color: alpha($color: #00060a);\n  font-size: medium;\n}\n\nmat-select {\n  background: #f3f6f9;\n  padding: 5px;\n  font-size: 14px;\n  border-radius: 5px;\n}\n\n.available {\n  color: alpha($color: #3d8fc5);\n  font-size: medium;\n}\n\n.login {\n  margin-top: 20px;\n}\n\n.form-group {\n  // to remove the background color of the autofilled elements\n  @include remove-autofill-background();\n  max-width: 500px;\n  width: 100%;\n  padding: 0px;\n\n  label {\n    font-size: 14px;\n    color: $gray-900;\n    font-weight: 500;\n    font-family: $primary-font;\n  }\n\n  .form-title {\n    font-size: 20px !important;\n  }\n\n  .form-control {\n    height: calc(1.5em + 0.75rem + 4px) !important;\n    border: none;\n    font-size: 14px;\n    font-weight: 500;\n    background-color: #f3f6f9;\n    color: $gray-800;\n\n    &:disabled {\n      cursor: not-allowed;\n      border: none;\n      box-shadow: none;\n    }\n  }\n\n  .error-section {\n    min-height: 18px;\n  }\n}\n\n.user-details {\n  .form-container {\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    // padding-right: 10px;\n    gap: 24px;\n\n    @media (max-width:768px) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    @media (max-width:570px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .fm-title {\n    width: 100%;\n    font-size: 18px;\n    font-weight: 500;\n    color: $primary;\n    margin-bottom: 10px;\n    padding-left: 0px;\n  }\n\n  .fm-titlee {\n    width: 100%;\n    font-size: 16px;\n    font-family: $primary-font;\n    font-weight: $ft-500;\n    margin-left: 5px;\n    color: $gray-800;\n    padding: 0px;\n    margin-bottom: 10px;\n  }\n\n  .custom-search {\n    margin-left: 40px;\n  }\n\n  .add-site {\n    width: 100%;\n    opacity: 1;\n    max-height: 250px;\n    height: 100%;\n    margin-left: 5px;\n    margin-bottom: 10px;\n\n    label {\n      font-size: 18px;\n      text-align: center;\n\n      padding-top: 10px;\n      padding-left: 5px;\n    }\n\n    input {\n      width: 15px;\n\n      height: 15px;\n    }\n  }\n\n  .item-class {\n    position: absolute;\n    left: 0;\n    padding-left: 20px;\n  }\n\n  .row {\n    padding-right: 10px;\n    padding: 0px 10px;\n  }\n\n  .roles-container {\n    width: 100%;\n  }\n\n  mat-grid-tile {\n    flex-direction: column;\n  }\n\n  .form-group {\n    // to remove the background color of the autofilled elements\n    @include remove-autofill-background();\n    max-width: 500px;\n    width: 100%;\n    padding: 0px;\n\n    label {\n      font-size: 14px;\n      font-weight: 500;\n    }\n\n    .form-title {\n      font-size: 20px !important;\n    }\n\n    .form-control {\n      height: calc(1.5em + 0.75rem + 4px) !important;\n      border: none;\n      font-size: 14px;\n      background-color: #f3f6f9;\n\n      &:disabled {\n        cursor: not-allowed;\n        border: none;\n        box-shadow: none;\n      }\n    }\n\n    .error-section {\n      min-height: 18px;\n    }\n  }\n}\n\n.form-title {\n  font-size: 20px;\n  margin-top: 40px;\n  font-weight: normal;\n}\n\n.form-actions {\n  padding: 35px 35px 0 0;\n  padding-top: 0px;\n  padding-right: 0px;\n  width: 100%;\n  text-align: right;\n\n  .submit-class {\n    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n  }\n\n  .submit-class {\n    @include create-buttons($primary,\n      $white,\n      6px,\n      12px,\n      120px,\n      40px,\n      18px,\n      300,\n      20px);\n    margin-top: -5%;\n  }\n\n  .cancel-class {\n    @include create-buttons($white,\n      $primary,\n      6px,\n      12px,\n      120px,\n      40px,\n      18px,\n      300,\n      20px);\n    border: 1px solid $primary;\n    margin-right: 10px;\n    margin-top: -5%;\n  }\n}\n\n.permissions-main-div {\n  max-height: 45vh;\n  overflow-y: auto;\n  padding: 1% 3% 2% 0.5%;\n  border: 1px solid #ccc;\n  margin-top: 1%;\n  margin-bottom: 1%;\n}\n\n.each-row-cls {\n  padding-bottom: 7px;\n}\n\n.permissions-indvi-col {\n  padding-left: 0px !important;\n}\n\n.module-name {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.set-name {\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n\n@media (min-width: 1025px) and (max-width: 1440px) {}\n\n@media (min-width: 522px) and (max-width: 772px) {\n  .add-site {\n    margin-left: 10px;\n    opacity: 1;\n    max-height: 200px;\n    margin-left: 5px;\n    margin-bottom: 10px;\n    width: 70%;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    margin-bottom: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .create-role {\n    height: fit-content;\n  }\n}\n\n@media (max-width: 767px) {\n  .details {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n\n    .form-group {\n      width: 90%;\n    }\n  }\n\n  .header {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .form-actions {\n    display: flex;\n    justify-content: right;\n    margin-left: 20px;\n  }\n\n  .layout-header {\n    width: 100%;\n  }\n\n  .addSites {\n    display: grid;\n  }\n}\n\n@media (max-width: 300px) {\n  .details {\n    display: grid;\n    grid-template-columns: 1fr;\n\n    .form-group {\n      width: 90%;\n    }\n  }\n\n  .searchText {\n    width: 160px;\n  }\n\n  .header {\n    margin-bottom: 25px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
